import { render } from "./Solutions.vue?vue&type=template&id=8580938c&ts=true&lang=pug"
import script from "./Solutions.vue?vue&type=script&lang=ts"
export * from "./Solutions.vue?vue&type=script&lang=ts"

import "./Solutions.vue?vue&type=style&index=0&id=8580938c&lang=css"

import exportComponent from "/Users/lauriel/gitRepos_work/hero/hero_web_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__